import { useQuery } from '@tanstack/react-query';
import { CcFeatureAccess } from 'containers/PostPaidFlow/Home2/services';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

import { setFeatureAccess } from 'redux/actions/Local/setFeatureAccess';
import store from 'redux/store';

export const useFeatureAccess = () => {
	const [features, setFeatures] = useState({});
	const dispatch = useDispatch();
	const homeDetails = useSelector((state) => state?.homeDetails);
	useEffect(() => {
		const fetchfeatures = async () => {
			try {
				const response = await CcFeatureAccess();
				setFeatures(response);
				dispatch(setFeatureAccess(response));
			} catch (err) {
				toast.error(err);
			}
		};

		if (homeDetails?.accountStatus && homeDetails?.accountStatus !== 'NA') {
			fetchfeatures();
		}
	}, [homeDetails?.accountStatus]);

	return features;

	// const dispatch = useDispatch();

	// return useQuery({
	// 	queryKey: ['featureAccess'],
	// 	queryFn: CcFeatureAccess,
	// 	onSuccess: (featureAccess) => {dispatch(setFeatureAccess(featureAccess))},
	// 	staleTime: 5000,
	// 	cacheTime: 10000,
	// 	enabled: !store.getState()?.featureAccess?.BBPS ? true : false,
	// });
};
